import { FaTimes } from "react-icons/fa";
import { useState, useMemo } from "react";

const FilterModal = ({ isOpen, onClose, onApply, data = [] }) => {
  const [timeOfDay, setTimeOfDay] = useState("");
  const [provider, setProvider] = useState("");

  

const providers = useMemo(() => {
  return [
    ...new Set([
      "Dr. Bobby Malik MD",
      ...data.map((i) => i.provider_name).filter(Boolean),
    ]),
  ];
}, [data]);


if (!isOpen) return null;
  const handleClear = () => {
    setTimeOfDay("");
    setProvider("");
    onApply?.({ timeOfDay: "", provider: "" });
    onClose();
  };

  const handleApply = () => {
    onApply?.({ timeOfDay, provider });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-3">
      <div className="w-full max-w-[620px] mt-5 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        
        {/* Header */}
        <div className="relative px-4 py-2 mt-2 border-b">
          <div className="flex items-center justify-between">
            <h2 className="text-[18px] font-bold text-[#111827]">
              Filter
            </h2>
            <button
              className="p-2 rounded-md hover:bg-gray-100 text-gray-500"
              onClick={onClose}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="px-4 py-3 text-start space-y-6">
          
          {/* Time of day */}
          <div>
            <p className="text-sm text-[#111827] font-semibold mb-3">
              Time of day
            </p>
            <div className="flex gap-3 flex-wrap">
              <PillButton
                label="Morning"
                selected={timeOfDay === "morning"}
                onClick={() => setTimeOfDay("morning")}
              />
              <PillButton
                label="Afternoon"
                selected={timeOfDay === "afternoon"}
                onClick={() => setTimeOfDay("afternoon")}
              />
            </div>
          </div>

          {/* Providers */}
          <div>
            <p className="text-sm font-semibold text-[#111827] mb-3">
              Providers
            </p>
            <div className="flex gap-3 flex-wrap">
              {providers.map((name) => (
                <PillButton
                  key={name}
                  label={name}
                  selected={provider === name}
                  onClick={() => setProvider(name)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t bg-[#F4F4F5] flex items-center justify-center gap-3">
          <button
            className="py-2 w-[50%] rounded-[10px] border border-gray-300 bg-white text-[#374151] hover:bg-gray-50"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            className="w-[50%] py-2 rounded-[10px] bg-black text-white hover:opacity-90"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

/* ---------------- Pill Button ---------------- */

const PillButton = ({ label, selected, onClick }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 text-sm transition-all outline-none focus:outline-none ${
      selected
        ? "bg-[#E88D67] text-white shadow-[0_10px_15px_-3px_rgba(232,141,103,0.20),0_4px_6px_-4px_rgba(232,141,103,0.20)]"
        : "bg-[#F9FAFB] text-[#374151] border border-[#E5E7EB]"
    }`}
    style={{ borderRadius: "9999px" }}
  >
    {label}
  </button>
);

export default FilterModal;
